<template>
  <div class="pie-chart-block">
    <div
      v-if="chartTitle"
      class="w-100 text-center chart-title"
      v-text="chartTitle"
    />
    <pie-chart
      class="p-4"
      :chart-data="chartData"
      @legendGenerated="setLegendHtml"
    />
    <div v-html="legendHtml" />
  </div>
</template>

<script>

export default {
  name: 'pieChartBlock',
  components: {
    'pie-chart': () => import(/* webpackChunkName: "pieChart" */ './pieChart.vue'),
  },
  props: {
    /**
     * chart title
     */
    chartTitle: {
      type: String,
      default: null,
    },
    /**
     * charthoz szükséges adat object
     *
     * @type {{
     *   datasets: [
     *     {
     *       backgroundColor: [
     *          String,
     *       ],
     *       data: [
     *          Number,
     *       ],
     *       labels: [
     *          String,
     *       ],
     *       percent: [
     *          Number,
     *       ],
     *       unit: String,
     *     },
     *   ],
     *   labels: [],
     * }}
     */
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      /**
       * generált legend html a chart alá
       */
      legendHtml: null,
    }
  },
  methods: {
    /**
     * generált legends html beirása a saját változonkba
     *
     * @param legendHtml
     */
    setLegendHtml(legendHtml) {
      this.legendHtml = legendHtml
    },
  },
}
</script>
<style scoped lang="scss">
.pie-chart-block {
  max-width: 100%;

  .chart-title {
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
  }
}
</style>
